import { getCookie, RawSfError, setCookie, SfApiResponse } from '@hfc/ui-core';
import { AxiosError } from 'axios';
import { UUID } from '@hfc/common';
import { SmallBusinessSentAppsRepository } from '@/application/smallBusiness/domain/SmallBusinessSentAppsRepository';

export class SmallBusinessSentAppsCookie implements SmallBusinessSentAppsRepository {

  public async setSentApplicationUuid (uuid: UUID): Promise<SfApiResponse> {
    try {
      setCookie(`SmallBusinessApplicationSent-${uuid}`, JSON.stringify(uuid), 2);

      return {
        success: true,
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

  public async isApplicationUuidSendable (uuid: UUID): Promise<SfApiResponse<boolean>> {
    try {
      const exists = getCookie(`SmallBusinessApplicationSent-${uuid}`);

      if (exists) {
        throw new Error('Your application was already completed');
      }

      return {
        success: true,
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

}
